import type { FunctionComponent } from 'react'

import styles from './bento-three-squares.module.scss'
import BentoPieceSquare from '@contentful-components/bento-box/pieces/bento-piece-square'
import type { BentoThreeSquaresFragment } from '@graphql/queries/GetBentoThreeSquares.graphql'

export const BentoThreeSquares: FunctionComponent<Props> = ({ pieces }) => {
    const squareOne = pieces?.items[0]
    const squareTwo = pieces?.items[1]
    const squareThree = pieces?.items[2]

    return (
        <div className={styles.container}>
            <div className={`${styles.flexContainer}`}>
                <div className={`${styles.boxFirst}`}>
                    <div className={styles.boxFirstContainer}>
                        <div className={styles.boxOneContent}>
                            <BentoPieceSquare square={squareOne} />
                        </div>

                        <div className={styles.boxTwoContent}>
                            <BentoPieceSquare square={squareTwo} />
                        </div>

                        <div className={styles.boxThreeContent}>
                            <BentoPieceSquare square={squareThree} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BentoThreeSquares

type Props = Omit<BentoThreeSquaresFragment, 'sys' | 'type'> & {
    index?: number
}
